import { useRef } from 'react';

export function useStableIds(ids: string[]) {
  const ref = useRef(ids);
  const isSame = ref.current.length === ids.length && ref.current.every((_, i) => ref.current[i] === ids[i]);

  if (!isSame) {
    ref.current = ids;
  }

  return ref.current;
}
